import { checkoutOptimizationStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

export const createCheckoutTree = {
  name: "createCheckoutTree" as const,
  input: z.object({ steps: checkoutOptimizationStepArraySchema }),
  output: z.object({ checkoutTreeId: z.string() }),
};
